// OTel log provider MUST be initialized before any other imports that use the logger
import { setupOtelLogProvider } from '@org-avp/logger/otel-layer';
import { DIST_ENDPOINTS } from '@org-avp/naap-models';
import { STAGE } from '@/config/env';
import { initMetrics } from '@/config/metrics';
import * as pkg from '../package.json';

setupOtelLogProvider({
  namespace: 'naap',
  name: 'naap-kiosk',
  version: pkg.version,
  stage: STAGE,
  orgId: 'dist',
  url: `${DIST_ENDPOINTS[STAGE].baseUrl}/v1/logs`,
  apiKey: DIST_ENDPOINTS[STAGE].apiKey,
});

// Dynamic import ensures all app modules (including lib/mqtt/metrics.ts)
// evaluate AFTER the MeterProvider is globally registered.
// Static imports are hoisted by the ES module system and would evaluate
// before initMetrics() runs if placed in this file or index.tsx directly.
void initMetrics().then(() => import('./index'));
